import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import { jsPDF } from 'jspdf';

export type IDownloadImageType = 'jpeg' | 'png' | 'image' | 'pdf';

export const captureRemoveClassName = 'dbi-capture__text-overflow-processor-on';
export const captureExpendClassName = 'dbi-capture__text-overflow-processor-off';
const DEFAULT_FILE_NAME = '页面截屏';

const getImageFileSuffix = (type: IDownloadImageType) => {
  if (type === 'pdf') return 'jpeg';
  if (type === 'image') return 'png';
  return type;
};

export const downloadImage = (cfg: {
  url: string;
  fileName?: string;
}) => {
  const url = cfg?.url || '';
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const iframe = document.createElement('iframe');
  const linker = document.createElement('a');
  iframe.style.display = 'none';
  linker.setAttribute('href', url);
  linker.setAttribute('download', fileName);
  document.body.appendChild(iframe);
  linker.click();
  document.body.removeChild(iframe);
};

export const downloadPDF = (cfg: {
  url: string;
  width: number;
  height: number;
  fileName?: string;
}) => {
  const url = cfg?.url || '';
  const width = cfg?.width;
  const height = cfg?.height;
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const pdf = new jsPDF(width >= height ? 'l' : 'p', 'px', [width, height]);
  pdf.addImage(url, 'JPEG', 0, 0, width, height);
  pdf.save(fileName + '.pdf');
};

export const downloadPDFNew = async (cfg: {
  canvas: HTMLCanvasElement;
  fileName?: string;
}) => {
  const canvas = cfg?.canvas;
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  return html2pdf()
    .set({
      // PDF自动分页配置
      // pagebreak: { mode: ['avoid-all', 'css'] },
      // [top,left,bottom,right]
      // margin: [0, 10, 0, 10],
      margin: 0,
      image: {
        type: 'jpeg',
        quality: 1,
      },
      thenExternal: () => {
      },
    })
    .from(canvas, 'canvas')
    .toPdf()
    .save(fileName + '.pdf');
};

export const captureNode = async (cfg: {
  type?: IDownloadImageType;
  node: HTMLElement;
  nodeOptions?: any;
  options?: any;
  fileName?: string;
}) => {
  const type = cfg?.type || 'image';
  const node = cfg?.node;
  const nodeOptions = cfg?.nodeOptions || {};
  const options = cfg?.options || {};
  const fileName = cfg?.fileName || DEFAULT_FILE_NAME;
  const { onclone, ...remainOptions } = options || {};
  const width = parseFloat(getComputedStyle(node).getPropertyValue('width'));
  const height = parseFloat(getComputedStyle(node).getPropertyValue('height'));
  const canvas = await html2canvas(node || document.body, {
    ...remainOptions,
    useCORS: true,
    scale: window.devicePixelRatio,
    imageTimeout: 60 * 1000,
    backgroundColor: '#f2f3f5',
    width,
    height,
    windowWidth: width,
    windowHeight: height,
    onclone(document, element) {
      if (!element) return;
      if (nodeOptions?.othersOptions) {
        Object.keys(nodeOptions.othersOptions).forEach((item) => {
          const el = element?.querySelectorAll<HTMLElement>(`.${item}`);
          el?.forEach((t) => {
            t.style.cssText = nodeOptions.othersOptions?.[item];
          });
        });
      }
      const rootNode = document.querySelector<HTMLElement>('#root');
      const hideEls = element?.querySelectorAll<HTMLElement>(`.${captureRemoveClassName}`);
      const showEls = element?.querySelectorAll<HTMLElement>(`.${captureExpendClassName}`);
      document.body.style.height = 'auto';
      if (rootNode) {
        rootNode.style.height = 'auto';
      }
      hideEls?.forEach((el) => {
        el.style.display = 'none';
      });
      showEls?.forEach((el) => {
        if (!el) return;
        el.style.display = 'block';
        // @ts-ignore
        el.style['-webkit-box-orient'] = 'unset';
      });
      onclone?.(document, element);
    },
  });
  const imageFileSuffix = getImageFileSuffix(type);
  const dataURL = canvas.toDataURL(imageFileSuffix, 1);

  if (['png', 'image'].includes(type)) {
    downloadImage({
      url: dataURL,
      fileName: `${fileName}.${imageFileSuffix}`,
    });
  }
  if (type === 'pdf') {
    downloadPDF({
      url: dataURL,
      width: nodeOptions?.width || width,
      height: nodeOptions?.height || height,
      fileName,
    });
  }
};
